package com.gsb.vyapar.bhagya.presentation.auth.event

sealed class AuthUiEvents {
    data class SendMobileOtp(val mobile: String) : AuthUiEvents()
    data class SendEmailOtp(val email: String) : AuthUiEvents()
    data class VerifyOtp(val otp: String) : AuthUiEvents()
}